import React, { useContext, useEffect, useState } from "react";
import { getAllGame } from "../../../api/user";
import CardGridSkeleton from "../../../components/Skeleton/CardGridSkeleton";
import { GameContext } from "../../../store/game/GameContext";
import Welcome from "../Welcome";
import Game from "../Game";
import { useOutletContext } from "react-router";

/**
 * FROZEN SNAPSHOT — the pre-revamp League Play landing, exactly as it is on
 * `main` / `UI/portfilio` (src/pages/Game/FindGames.jsx at that revision).
 *
 * It is mounted at /oldcontest purely so the old and new layouts can be put
 * side by side. Do NOT "improve" this file: the moment it drifts it stops being
 * a reference. When the comparison is no longer needed, delete this folder and
 * the /oldcontest route in App.jsx.
 *
 * Its dependencies (Game, Welcome, GameSearchBar, Menu, CardGridSkeleton) are
 * untouched by the revamp, so this renders the genuine old card grid, and the
 * old chrome (grey "Leagues" heading band + search bar + tab menu) comes from
 * the shared Contest wrapper, which only hides those on the new /contest.
 */
const OldFindGames = () => {
  const { fetching, setFetching } = useContext(GameContext);
  const { search } = useOutletContext(); // Access search from Outlet context
  const [games, setGames] = useState([]);

  const fetchGame = async (controller) => {
    try {
      setFetching(true);
      const response = await getAllGame({ signal: controller.signal });
      if (response?.status === 200) {
        setGames(response.data.data);
      } else {
        console.log("Error occurred");
      }
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("Fetch aborted");
      } else {
        console.log(error);
      }
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    fetchGame(controller);

    return () => {
      localStorage.removeItem("game_type");
      localStorage.removeItem("isAuthenticated");
      controller.abort();
      console.log("Clean up: fetch aborted");
    };
  }, []);

  // Filter games based on search query
  const filteredGames = games.filter(
    (game) =>
      (game.title && game.title.toLowerCase().includes(search.toLowerCase())) ||
      (game.description &&
        game.description.toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <div
      className={`${
        games.length === 0
          ? "block"
          : "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 lg:gap-x-16 gap-x-8 gap-y-7"
      } mt-5 md:mt-12 pl-8 pr-5 min-h-20`}
    >
      {fetching ? (
        <CardGridSkeleton cards={5} />
      ) : (
        <>
          {games.length === 0 && !search && <Welcome />}

          {games.length > 0 && filteredGames.length === 0 && (
            <p>No league found with that title or description.</p>
          )}

          {filteredGames.map((game) => (
            <Game key={game.id} game={game} />
          ))}
        </>
      )}
    </div>
  );
};

export default OldFindGames;
